import { createSlice } from "@reduxjs/toolkit";

export const stepLocationSlice = createSlice({ //reducers for both hours in global state
    name: 'stepLocation',
    initialState:{},
    reducers: {
        setStep: (currentState, action) => {
            return action.payload
        },
        nextStep: (currentState, action) => {
            return currentState+1
        },
        prevStep: (currentState, action) => {
            return currentState-1
        }
    }
});